import { h, Component } from 'preact';
import ChatFrame from './chat-frame';
import {
    desktopWrapperStyle,
    mobileOpenWrapperStyle,
    mobileClosedWrapperStyle
} from "./style";

export default class Widget extends Component {

    constructor() {
        super();

        this.state = {
            isChatOpen: false,
            frameMounted: false,
            wasChatOpened: this.wasChatOpened(),
            isHidden: false,
            unreadCount: 0
        };
    }

    componentDidMount() {
        window.addEventListener('message', this.handleFrameMessage);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleFrameMessage);
    }

    handleFrameMessage = (event) => {
        if (!event.data || !event.data.type) {
            return;
        }

        if (event.data.type === 'intergram-close-chat') {
            this.setState({
                isChatOpen: false,
                frameMounted: true,
                wasChatOpened: true
            });

            return;
        }

        if (event.data.type === 'intergram-admin-message') {
            if (!this.state.isChatOpen) {
                this.setState({
                    unreadCount: this.state.unreadCount + 1
                });
            }
        }
    };

    render({ conf, isMobile }, { isChatOpen, frameMounted, isHidden, unreadCount }) {
        if (isHidden) {
            return null;
        }

        const wrapperWidth = {
            width: conf.desktopWidth
        };

        const desktopHeight = (window.innerHeight - 100 < conf.desktopHeight)
            ? window.innerHeight - 90
            : conf.desktopHeight;

        let wrapperStyle;

        if (!isChatOpen) {
            wrapperStyle = {
                ...mobileClosedWrapperStyle,
                width: '64px',
                height: '64px',
                overflow: 'visible'
            };
        } else if (!isMobile) {
            wrapperStyle = {
                ...desktopWrapperStyle,
                ...wrapperWidth
            };
        } else {
            wrapperStyle = mobileOpenWrapperStyle;
        }

        const server = window.intergramServer || window.location.origin;
        const avatarUrl = conf.closedChatAvatarUrl || (server + '/media/kefu.png');

        return (
            <div style={wrapperStyle}>

                <button
                    type="button"
                    onClick={this.openChat}
                    title={conf.titleClosed || '联系客服'}
                    style={{
                        width: '64px',
                        height: '64px',
                        minWidth: '64px',
                        minHeight: '64px',
                        maxWidth: '64px',
                        maxHeight: '64px',
                        borderRadius: '50%',
                        border: '2px solid #fff',
                        padding: '0',
                        margin: '0',
                        background: '#fff',
                        cursor: 'pointer',
                        boxShadow: '0 8px 24px rgba(31, 140, 235, 0.35)',
                        outline: 'none',
                        overflow: 'visible',
                        display: isChatOpen ? 'none' : 'block',
                        position: 'relative'
                    }}
                >
                    <img
                        src={avatarUrl}
                        alt="联系客服"
                        style={{
                            width: '100%',
                            height: '100%',
                            display: 'block',
                            objectFit: 'cover',
                            borderRadius: '50%'
                        }}
                    />

                    {
                        unreadCount > 0 ? (
                            <span
                                style={{
                                    position: 'absolute',
                                    top: '-6px',
                                    right: '-6px',
                                    minWidth: unreadCount > 9 ? '26px' : '22px',
                                    height: '22px',
                                    padding: unreadCount > 9 ? '0 6px' : '0',
                                    borderRadius: '999px',
                                    background: '#ff3b30',
                                    color: '#fff',
                                    fontSize: '12px',
                                    fontWeight: '700',
                                    lineHeight: '1',
                                    textAlign: 'center',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.22)',
                                    border: '2px solid #fff',
                                    boxSizing: 'border-box',
                                    zIndex: 2147483647,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none'
                                }}
                            >
                                {unreadCount > 99 ? '99+' : unreadCount}
                            </span>
                        ) : null
                    }
                </button>

                <div
                    style={{
                        display: isChatOpen ? 'block' : 'none',
                        width: isChatOpen ? '100%' : '0px',
                        height: isMobile ? '100%' : desktopHeight,
                        overflow: 'hidden'
                    }}
                >
                    {
                        frameMounted ? (
                            <ChatFrame {...this.props} />
                        ) : null
                    }
                </div>
            </div>
        );
    }

    openChat = () => {
        this.setState({
            isChatOpen: true,
            frameMounted: true,
            wasChatOpened: true,
            unreadCount: 0
        });

        if (!this.wasChatOpened()) {
            this.setCookie();
        }
    }

    setCookie = () => {
        let date = new Date();
        let expirationTime = parseInt(this.props.conf.cookieExpiration);

        date.setTime(date.getTime() + (expirationTime * 24 * 60 * 60 * 1000));

        let expires = "; expires=" + date.toGMTString();

        document.cookie = "chatwasopened=1" + expires + "; path=/";
    }

    getCookie = () => {
        var nameEQ = "chatwasopened=";
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }

            if (c.indexOf(nameEQ) == 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }

        return false;
    }

    wasChatOpened = () => {
        return this.getCookie() === false ? false : true;
    }

}


// WEBPACK FOOTER //
// ./src/widget/widget.js